// Small shared sim types: rects/points (signed-16 coordinate structs), side masks, and
// the Enum cursor used by area enumeration. game/ht.h / mpshared.

import { s16 } from './math/int32.ts';

export interface WPoint {
  wx: number;
  wy: number;
}
export interface TPoint {
  tx: number;
  ty: number;
}

/** The bare coordinate fields a TRect exposes — the structural shape callers fill in as an
 *  out-param (e.g. GetTileRect). TRect satisfies it; so do plain {left,top,right,bottom}
 *  literals. Type-only convenience; no runtime entity. */
export interface TRectLike {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

/** TRect — tile-coord rect, [left,top) inclusive-exclusive like the C++. */
export class TRect {
  left = 0;
  top = 0;
  right = 0;
  bottom = 0;
  Set(l: number, t: number, r: number, b: number): void {
    this.left = s16(l);
    this.top = s16(t);
    this.right = s16(r);
    this.bottom = s16(b);
  }
  PtIn(tx: number, ty: number): boolean {
    return tx >= this.left && tx < this.right && ty >= this.top && ty < this.bottom;
  }
}

// mpshared GetSideMask macro: (1 << side)
export const GetSideMask = (side: number): number => 1 << side;

// game/ht.h kEnmFirst — the Enum cursor's "not started" sentinel
export const kEnmFirst = 0xffffffff;

/** Enum — the C++ enumeration cursor (m_dwUser/m_wUser). */
export class Enum {
  m_dwUser = kEnmFirst; // dword
  m_wUser = 0; // word
}
